import styled from "styled-components/macro";

const Button = styled.button`
  cursor: pointer;
  background: ${(props) => props.theme.colors.primary2};
  color: white;
  font-size: 10px;
  font-family: unset;
  font-weight: ${(props) => props.theme.font.weights.semibold};
  text-transform: uppercase;
  margin: 0.5em;
  border-radius: 3px;
  border: 1px solid ${(props) => props.theme.colors.primary2};

  :hover {
    background: ${(props) => props.theme.colors.primary};
    border: 1px solid ${(props) => props.theme.colors.primary};
  }
  :focus {
    outline: none;
  }

  :disabled {
    cursor: default;
    color: ${(props) => props.theme.colors.secondary};
    background: ${(props) => props.theme.colors.secondary2};
    border: 1px solid ${(props) => props.theme.colors.secondary2};
    :hover {
      background: ${(props) => props.theme.colors.secondary2};
      border: 1px solid ${(props) => props.theme.colors.secondary2};
    }
  }
`;

export default Button;
